class CartRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    new IntersectionObserver(this.handleIntersection.bind(this)).observe(this);
  }

  handleIntersection(entries, observer) {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(this);

    this.fetchRecommendations(this.dataset.url, true);
  }

  fetchRecommendations(url, allowFallback) {
    fetch(url)
      .then((response) => response.text())
      .then((text) => {
        const html = new DOMParser()
          .parseFromString(text, 'text/html')
          .querySelector('.shopify-section');
        if (html === null) return;

        const recommendations = html.querySelector('cart-recommendations');

        // Si la respuesta trae contenido, lo inyectamos.
        if (recommendations && recommendations.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML;
        } else if (allowFallback && this.dataset.fallbackUrl) {
          // Si vino vacia y hay fallback, reintentar con intent=related.
          this.fetchRecommendations(this.dataset.fallbackUrl, false);
          return;
        }

        // Scroll del mini-cart hacia arriba luego de cargar.
        const miniCartMain = document.querySelector('#main-cart-items');
        if (miniCartMain) {
          miniCartMain.scrollTop -= miniCartMain.scrollHeight;
        }
      })
      .catch((e) => {
        console.error('[cart-recommendations]', e);
      });
  }
}

customElements.define('cart-recommendations', CartRecommendations);
